import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@api/client/apiClient';
import { queryKeys } from '@api/queryKeys';
import type { UpdateOperation } from '../types';
import { OPERATION_POLL_INTERVAL } from '../constants';

export function useOperation(operationId: string | null) {
  return useQuery({
    queryKey: queryKeys.updates.operation(operationId ?? ''),
    queryFn: () => apiClient.get<UpdateOperation>(`/updates/operations/${operationId}`),
    enabled: !!operationId,
    refetchInterval: (query) => {
      const status = query.state.data?.status;
      if (status === 'running' || status === 'queued') return OPERATION_POLL_INTERVAL;
      return false;
    },
  });
}
